import merge from 'deepmerge'
import BaseMessages from './messages'
import BasePermissionMessages from './permissions/BasePermissionMessages'

const messages = merge.all([
    BaseMessages,
    BasePermissionMessages
])

export default messages
